import BasePage from "../../base/BasePage";
// import {NavBar} from "nq-component";
import NavBar from "../../components/navigation";
import React from "react";
import SettingsPresenter from "./SettingsPresenter";
import { Button, InputFactory } from "nq-component";
import browseFile from "../../browseFile";
import { addSchemaUseCase } from "../../usecases/schema/usecases";
import CardView from "../../components/common/CardView";
import AccountPage from "../account/AccountPage";

class Settings extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new SettingsPresenter(this, addSchemaUseCase());
    this.state = { generalNoti: false, department: false, personal: false };
  }

  showProgress() {
    this.setState({ progress: true });
  }

  hideProgress() {
    this.setState({ progress: false });
  }

  exportClick() {
    this.presenter.export();
  }

  importClick() {
    browseFile("*").then((files) => {
      if (files.length > 0) {
        const file = files[0];
        this.presenter.import(file);
      }
    });
  }

  handleDepartment() {
    this.setState((prevState) => ({
      department: !prevState.department,
    }));
  }

  handlePersonal() {
    this.setState((prevState) => ({
      personal: !prevState.personal,
    }));
  }

  handleGeneral() {
    console.log("handleGeneral function called");
    this.setState((prevState) => ({
      generalNoti: !prevState.generalNoti,
    }));
  }

  render() {
    // const { generalNoti, department, personal } = this.state;

    return (
      <>
        <div className="row" style={{ height: "100%" }}>
          <div
            className="container-fluid d-flex flex-column p-5"
            style={{ marginTop: "4rem" }}
          >
            <div
              className="d-flex mb-4"
              style={{ borderBottom: "1.5px solid #d3d3d3" }}
            >
              <p style={{ fontSize: "1rem" }}>You are here: My Settings</p>
            </div>

            <div
              className="row m-auto"
              style={{ width: "100%", height: "auto" }}
            >
              <div className="col-lg-6 mb-2" style={{ height: "15rem" }}>
                <AccountPage />
              </div>
              {/* <div className="col-lg-6 mb-2" style={{ height: "35rem" }}>
                <CardView style={{ padding: 0, borderRadius: 0 }}>
                  <div
                    className="d-flex mb-2"
                    style={{ borderBottom: "1.5px solid #d3d3d3" }}
                  >
                    <p
                      style={{
                        fontSize: "1rem",
                        paddingTop: "1rem",
                        paddingLeft: "2rem",
                      }}
                    >
                      Notification Settings
                    </p>
                  </div>
                  <div className="w-100 h-100 p-4">
                    <div className="row d-flex h-100 justify-content-around align-items-center">
                      <div className="column">
                        <div className="d-flex row">
                          <div className="col-8">
                            <p>General Notifications</p>
                            <p>Receive organization wide notifications</p>
                          </div>
                          <div className="col-4 m-auto">
                            <Button
                              onClick={this.handleGeneral.bind(this)}
                              className="btn btn-transparent"
                            >
                              <i
                                className={
                                  this.state.generalNoti
                                    ? "bi bi-toggle-off"
                                    : "bi bi-toggle-on"
                                }
                                style={{ zoom: 2 }}
                              ></i>
                            </Button>
                          </div>
                        </div>

                        <div
                          style={{
                            height: "1px",
                            width: "100%",
                            backgroundColor: "#d3d3d3",
                          }}
                        />
                      </div>
                      <div className="column">
                        <div className="d-flex row">
                          <div className="col-8">
                            <p>Department Notifications</p>
                            <p>Receive department notifications</p>
                          </div>
                          <div className="col-4 m-auto">
                            <Button
                              onClick={this.handleDepartment.bind(this)}
                              className="btn btn-transparent"
                            >
                              <i
                                className={
                                  this.state.department
                                    ? "bi bi-toggle-off"
                                    : "bi bi-toggle-on"
                                }
                                style={{ zoom: 2 }}
                              ></i>
                            </Button>
                          </div>
                        </div>

                        <div
                          style={{
                            height: "1px",
                            width: "100%",
                            backgroundColor: "#d3d3d3",
                          }}
                        />
                      </div>
                      <div className="column">
                        <div className="d-flex row">
                          <div className="col-8">
                            <p>Personal Notifications</p>
                            <p>Receive personal notifications</p>
                          </div>
                          <div className="col-4 m-auto">
                            <Button
                              onClick={this.handlePersonal.bind(this)}
                              className="btn btn-transparent"
                            >
                              <i
                                className={
                                  this.state.personal
                                    ? "bi bi-toggle-off"
                                    : "bi bi-toggle-on"
                                }
                                style={{ zoom: 2 }}
                              ></i>
                            </Button>
                          </div>
                        </div>

                        <div
                          style={{
                            height: "1px",
                            width: "100%",
                            backgroundColor: "#d3d3d3",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </CardView>
              </div> */}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Settings;
